var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3 relative"},[_c('z-loading',{attrs:{"active":_vm.isLoading,"is-full-page":false}}),(!_vm.scanResults)?_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('ScanYourID')))]),_c('MBScan',{ref:"mbScan",attrs:{"doc-type":"scan-id"},on:{"results":_vm.onScanResult}}),_c('z-button',{staticClass:"mt-6 w-full",on:{"click":_vm.startScan}},[_vm._v(" "+_vm._s(_vm.$t('StartScan'))+" ")]),(
        _vm.$store.state.updateIdInfoResult &&
        _vm.$store.state.updateIdInfoResult.result
      )?_c('tutorial',{attrs:{"tutorial-name":_vm.$store.state.updateIdInfoResult.result.status ===
        'User is not eligible'
          ? 'enable_auth'
          : 'new_user'}}):_vm._e()],1):_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('ScanSuccessful')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }